module.exports = __webpack_public_path__ + "img/Daftars.8bd198bb.svg";